import { Button } from "components/atoms/button/button";
import { SubjectTag } from "components/subject-tag/subject-tag";
import { SubjectTagData } from "components/subject-tag/subject-tag.data";
import { format } from "date-fns";
import React from "react";
import { kelasLiveEvents } from "services/mixpanel/kelas-live-events";
import trackEvent from "services/mixpanel/mixpanel";
import { getIndonesianTimezone, trimString } from "utils/utils";
import { GuruJuaraBadge } from "../assets/guru-juara-badge";
import { PdfChip } from "../common/pdf-chip/pdf-chip";
import { VideoChip } from "../common/video-chip/video-chip";
import {
  didStudentAttendClass,
  getClassTimeStamp,
  getTimeStampFromDateString,
  getVideoMaterialCountForClass
} from "../utils";
import {
  ClassReportCardContainer,
  ClassReportCardMeta,
  ClassReportCardAttendance,
  ClassReportCardAttendanceMessage,
  ClassReportCardDetails,
  ClassReportCardDetailsHeading,
  ClassReportCardDetailsTeacher,
  ClassReportCardInfoItemContainer,
  ClassReportCardInfoItem,
  ClassReportCardFooter,
  ClassReportCardMaterialInfo
} from "./class-report-card.styles";
import { IClassReportCardProps } from "./class-report-card.types";
import { CheckCircle } from "components/icons/check-circle";
import { InfoIcon } from "components/icons/info";

const ClassReportCard: React.FC<IClassReportCardProps> = ({
  classSession,
  handleShowMoreDetails,
  isWidthApplied = true
}) => {
  const videoMaterialCount = getVideoMaterialCountForClass(classSession);
  const classAttended = didStudentAttendClass(classSession);
  const subjectTagData = SubjectTagData[classSession.subject.toUpperCase()];

  function onClick(e: React.MouseEvent<HTMLElement, MouseEvent>) {
    e.stopPropagation();
    trackEvent({
      eventName: kelasLiveEvents.classReportClicked
    });
    handleShowMoreDetails();
  }

  return (
    <ClassReportCardContainer onClick={onClick} isWidthApplied={isWidthApplied}>
      <ClassReportCardMeta>
        <SubjectTag
          backgroundColor={subjectTagData?.backgroundColor}
          color={subjectTagData?.color}
          text={subjectTagData?.text}
          iconSrc={subjectTagData?.iconSrc}
        />
        <ClassReportCardAttendance classAttended={classAttended}>
          {classAttended ? (
            <ClassReportCardAttendanceMessage>
              <CheckCircle /> <span>Hadir</span>
            </ClassReportCardAttendanceMessage>
          ) : (
            <ClassReportCardAttendanceMessage>
              <InfoIcon /> <span>Tidak hadir</span>
            </ClassReportCardAttendanceMessage>
          )}
        </ClassReportCardAttendance>
      </ClassReportCardMeta>
      <ClassReportCardDetails>
        <ClassReportCardDetailsHeading>
          {classSession.topic}
        </ClassReportCardDetailsHeading>
        <ClassReportCardDetailsTeacher>
          {trimString(classSession.teacher.name, 40)} <GuruJuaraBadge />
        </ClassReportCardDetailsTeacher>
        <ClassReportCardInfoItemContainer>
          <ClassReportCardInfoItem>
            {getClassTimeStamp(classSession.startDate)}
          </ClassReportCardInfoItem>
          <ClassReportCardInfoItem>
            {format(getTimeStampFromDateString(classSession.startDate), "k:mm")}{" "}
            {getIndonesianTimezone()}
          </ClassReportCardInfoItem>
          <ClassReportCardInfoItem>
            {classSession.duration} menit
          </ClassReportCardInfoItem>
        </ClassReportCardInfoItemContainer>
      </ClassReportCardDetails>
      <ClassReportCardFooter>
        <ClassReportCardMaterialInfo>
          {videoMaterialCount > 0 && <VideoChip value={videoMaterialCount} />}
          {classSession.studyMaterialUrls &&
            classSession.studyMaterialUrls.length && (
              <PdfChip value={classSession.studyMaterialUrls.length} />
            )}
        </ClassReportCardMaterialInfo>
        <Button variant="primary" onClick={onClick}>
          Cek materi kelas
        </Button>
      </ClassReportCardFooter>
    </ClassReportCardContainer>
  );
};

export { ClassReportCard };
